<template>
  <v-select
      v-model="currentCurrency"
      :items="$options.langList"
      :class="`currency-select-${index} global-select`"
      :attach="`.currency-select-${index}`"
      :menu-props="{ bottom: true, offsetY: true, closeOnClick: true }"
      @change="currencyChange($event)"
      hide-selected
  >
    <template v-slot:prepend-inner>
      <span class="icon-symbol">{{ currentCurrency === 'USD' ? '$' : '₴' }}</span>
    </template>
  </v-select>
</template>

<script>
  import { CURRENCY } from '@/constants';
  import { mapGetters } from 'vuex';
  import { SETTINGS_GETTERS, SETTINGS_MUTATIONS } from "@/store/modules/settings";

  export default {
    name: "LangSelect",
    langList: [
      // { text: CURRENCY.RUR, value: CURRENCY.RUR },
      { text: CURRENCY.UAH, value: CURRENCY.UAH },
      { text: CURRENCY.USD, value: CURRENCY.USD }
    ],
    props: {
      index: {type: String, default: ''},
    },
    data() {
      return {
        currentCurrency: this.currency,
      }
    },
    mounted() {
      if (!this.currency) {
        this.currency =  this.setCurrency();
      }
      this.currentCurrency = this.currency;
    },
    computed: {
      ...mapGetters('settings', { currency: SETTINGS_GETTERS.CURRENCY }),
    },
    methods: {
      currencyChange(currency) {
        this.$store.commit(`settings/${SETTINGS_MUTATIONS.SET_CURRENCY}`, currency);
        document.cookie = `site_currency=${currency}`;
      }
    },
    watch: {
      currency() {
        this.currentCurrency = this.currency;
      }
    }
  }
</script>
